module.exports = __webpack_public_path__ + "img/close.b66ca034.png";